import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import Toggle from 'dashboard/components/Toggle';

const ToggleField = ({ field: { name, value }, form, ...props }) => {
  const toggleFieldValue = () => {
    const newValue = !value;
    form.setFieldValue(name, newValue);
  };

  return <Toggle name={name} isToggled={value} onToggle={toggleFieldValue} {...props} />;
};

ToggleField.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

export default (props) => <Field component={ToggleField} {...props} />;
